import { Link } from "react-router-dom";
import { Scale, ShieldCheck, Leaf, BookOpen, Search, ArrowRight } from "lucide-react";
import { useContent } from "../context/ContentContext";

const ICONS = [Scale, ShieldCheck, Leaf, BookOpen];

export default function About() {
  const { c } = useContent();
  const a = c.about;
  return (
    <main>
      <section className="bg-[var(--navy)] py-16 lg:py-24">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#5aa0e0]">{a.heroEyebrow}</p>
          <h1 className="font-display mt-3 text-[38px] font-extrabold leading-tight tracking-tight text-white sm:text-[48px]">{a.heroTitle}</h1>
          <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-slate-300">{a.heroSubtitle}</p>
        </div>
      </section>

      <section className="bg-white py-16 lg:py-20">
        <div className="mx-auto max-w-[860px] px-5 lg:px-8">
          <p className="eyebrow">{a.missionEyebrow}</p>
          <h2 className="font-display mt-3 text-[30px] font-extrabold leading-tight tracking-tight text-[var(--ink)] sm:text-[38px]">{a.missionTitle}</h2>
          <p className="mt-5 text-[16px] leading-relaxed text-slate-500">{a.missionP1}</p>
          <p className="mt-4 text-[16px] leading-relaxed text-slate-500">{a.missionP2}</p>
        </div>
      </section>

      <section className="bg-[#f7f8fa] py-16 lg:py-20">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <p className="eyebrow">{a.standEyebrow}</p>
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
            {a.pillars.map((p, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <div key={i} className="rounded-2xl border border-slate-200 bg-white p-7">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--navy)] text-white"><Icon size={20} /></div>
                  <h3 className="font-display mt-5 text-[19px] font-bold text-[var(--ink)]">{p.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-slate-500">{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-[var(--navy)] py-16">
        <div className="mx-auto max-w-[1200px] px-5 text-center lg:px-8">
          <h2 className="font-display text-[30px] font-extrabold tracking-tight text-white sm:text-[38px]">{a.ctaTitle}</h2>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/providers" className="inline-flex items-center gap-2 rounded-xl bg-white px-6 py-3.5 text-[15px] font-semibold text-[var(--ink)] transition-colors hover:bg-slate-100"><Search size={17} /> {a.ctaPrimary}</Link>
            <Link to="/compare" className="group inline-flex items-center gap-2 rounded-xl bg-[var(--brand-blue)] px-6 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-[var(--brand-blue-hover)]">{a.ctaSecondary} <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" /></Link>
          </div>
        </div>
      </section>
    </main>
  );
}
